import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"
import ProjectIconUI5 from "../../../../../../gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../../gd-components/icons/@const";

export default function FieldProject_GlistGroupModern(props:FieldGlistGroupProps) {

    const project               = gd.session.projects.get(props.data.value)!
    const colorClass: string    = 'gd-c-{0}'.f(project.color)
    const classes: string       = Classes("ui5-group-by-project-2", colorClass)

    return (
        <div className={classes}>
            <ProjectIconUI5 className="group-icon m-r-10" size={ItemIconSize.SIZE_13} projectId={props.data.value} colorize={false}/>
            <div className="text">{project.name}</div>
        </div>
    )
}
